module.exports = __webpack_public_path__ + "img/image12.c0ad475b.png";